import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 30px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
      width: 250px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  max-width: 1180px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 0 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 340px;
    margin: 24px auto 0;
    padding: 0;
    gap: 40px;
  }
`;

export const TextBox1 = styled.div`
  flex: 1;
  text-align: center;
  font-size: 48px;
  font-weight: 200;
  line-height: 56px;
  text-align: left;
  color: #e4e4e4;

  p {
    color: #e4e4e4;
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    margin-bottom: 10px;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      line-height: 32px;
      margin-bottom: 16px;
    }
  }

  ul {
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    padding-left: 30px;
    color: #c3c3c3;
  }

  button {
    display: inline-flex;
    padding: 4px 20px 4px 16px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background-color: #f16024;
    border: none;
    border-radius: 2px;
    color: #f6f6f6;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    cursor: pointer;
    margin-bottom: 64px;
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #c3c3c3;
  text-align: left;
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 10 0%
    );
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 110%
    );
  }
`;
